import * as THREE from 'three';
import {textNetwork} from "../Text/TextNetwork";
import {Plane} from "./Plane";
import {PlaneBorder} from "./PlaneBorder";
import {Mesh, Object3D} from "three";

export function NetworkZone(
    scene: THREE.Scene,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number,
    color: number,
    borderColor: number,
    borderThickness: number,
    zoneName: string,
	id: string,
	sideOffset: number = 0,
): void {
    const group = new THREE.Group();

    // Créer le plan principal
    const planeRound: Mesh = Plane(width, height, radius, color);
    group.add(planeRound);

    // Créer la bordure avec extrusion
    const border: Object3D = PlaneBorder(width, height, radius, borderColor, borderThickness);
    group.add(border);

    // Naming
    const namingX: number = (x - width / 2) + 0.5;
    textNetwork(scene, namingX, y + 0.7, 0, width, zoneName, 0.3, id, borderColor);

    group.rotation.x = -Math.PI / 2;
    group.position.set(x, 0, y + height / 2);

	if (sideOffset > 0) {
		group.position.x = x + sideOffset;
	}

    scene.add(group);
}
